import { connect } from 'react-redux';

import { favoritePodcastToggle } from 'actions/favoritePodcast-actions';
import { getContentWidth } from 'store/reducers/content';
import { getIsFavoritePodcast } from 'store/reducers/favorites';
import PodcastDetailPageHeader from './PodcastDetailPageHeader';

const mapStateToProps = (state, ownProps) => ({
  isFavorite: getIsFavoritePodcast(state, ownProps),
  contentWidth: getContentWidth(state),
});

const mapDispatchToProps = {
  onFavoriteToggle: (podcast) => favoritePodcastToggle(podcast),
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastDetailPageHeader);
